import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import { Session } from "src/base/store/authSlice";
import { ReduxDataKey } from "src/base/store/store";

const PolicyConditionPage = ({ startOn }: { startOn?: number }) => {
  const { POS, fetchPOS } = useEBSSS();
  const { trans } = useEBSSSLayout();
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);

  useEffect(() => {
    fetchPOS();
  }, []);

  let checkPOS = sessionNow?.user?.user_service_term_conditions?.filter(
    (uspTOS) =>
      typeof uspTOS === "object" &&
      uspTOS?.term &&
      uspTOS?.term?.type === "privacy_policy"
  );
  let checkLastPOSAssign = checkPOS[checkPOS?.length - 1];

  return (
    <Page
      breads={[{ name: trans("website.menu-privacy-policy"), active: true }]}
    >
      <div className="d-flex flex-column">
        <div className="d-flex flex-column p-3">
          <span className="">{trans("website.menu-privacy-policy")}</span>
          <span className="">{POS?.terms?.published_at}</span>
          {sessionNow?.user?.id ? (
            <span className="">
              {trans("website.title-terms-conditions-accepted-at")}{" "}
              {typeof checkLastPOSAssign === "object"
                ? checkLastPOSAssign?.updated_at
                : new Date().toLocaleDateString()}
            </span>
          ) : (
            <></>
          )}
        </div>
        <div
          className="p-3 ebsss-terms-points"
          dangerouslySetInnerHTML={{
            __html: POS?.termTranslations?.content,
          }}
        ></div>
      </div>
    </Page>
  );
};

export default PolicyConditionPage;
